import { render } from "./homeTeachTools.vue?vue&type=template&id=3f0fea96&scoped=true"
import script from "./homeTeachTools.vue?vue&type=script&lang=js"
export * from "./homeTeachTools.vue?vue&type=script&lang=js"

import "./homeTeachTools.vue?vue&type=style&index=0&id=3f0fea96&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0fea96"]])

export default __exports__